'use strict';

const AdvancedFlowV3 = require('../../HomeyAPIV3/ManagerFlow/AdvancedFlow');

class AdvancedFlow extends AdvancedFlowV3 {

  static transformGet(item) {
    if (item.cards) {
      for (const card of Object.values(item.cards)) {
        card.id = `${card.ownerUri}:${card.id}`;
      }
    }

    delete item.broken;

    return item;
  }

  static transformSet(item) {
    if (item.cards) {
      for (const card of Object.values(item.cards)) {
        card.ownerUri = card.id.split(':', 3).join(':');
        card.id = card.id.split(':').reverse()[0];
      }
    }

    return item;
  }

}

module.exports = AdvancedFlow;
